<template>
<div class="ui segments">

  <div class="ui segment">
    <div class="ui breadcrumb">
      <router-link :to="{name:'home'}" class="section">Sākums</router-link>
      <span class="divider">/</span>
      <div class="active section">Pirkumu grozs</div>
    </div>
  </div>

  <cart-steps step="3" :confirmed="1"></cart-steps>
  <div class="ui attached segment">
    <div class="ui info icon message">
      <i class="notched circle loading icon"></i>
      <div class="content">
        <div class="header">
          Lūdzu uzgaidiet!
        </div>
        <p>Notiek maksājuma apstrāde...</p>
      </div>
    </div>
  </div>


</div>
</template>

<script>
import CartSteps from './CartSteps'

export default {
  components: {
    CartSteps
  },

  computed: {

    paymentData() {
      return this.$store.state.paymentStore.paymentData
    }
  },


  activated: function() {
    var token = this.$route.params.token;
    var data = { payment_token: token };
    this.$store.dispatch('updateCartPayment', data).then((response) => {
      this.$router.push({
          name: 'cart-confirmation-orderid', 
          params: {
              orderid: this.paymentData.order.id
          }
      });
    }).catch((error) => {
      this.$router.push({
          name: 'cart-canceled'
      });
    });


  },


}
</script>



// WEBPACK FOOTER //
// CartProcessPage.vue?faa3e9fa